module.exports = __webpack_public_path__ + "static/media/getFetch.2b2b7da4.cjs";